const dataFaqs = [
  {
    id: 1,
    title: 'What is the main difference between Robo and Algo trading?',
    text: 'Robo trading is strategy-based and riskier, while Algo trading uses advanced automation for faster, accurate, and lower-risk execution.',
    show: ''
  },
  {
    id: 2,
    title: 'Who typically uses Robo trading?',
    text: 'Average investors with small capital who want basic trade automation.',
    show: ''
  },
  {
    id: 3,
    title: 'Who uses Algo trading?',
    text: 'Professional traders, investment firms, hedge funds, and institutions.',
    show: ''
  },
  {
    id: 4,
    title: 'How does Robo trading operate?',
    text: 'Runs on local computers using MetaTrader, making it vulnerable to power or internet failures.',
    show: ''
  },
  {
    id: 5,
    title: 'How does Algo trading operate?',
    text: 'Executes trades on cloud servers (like AWS) using multiple coded strategies for high-frequency, low-latency trading.',
    show: ''
  },
  {
    id: 6,
    title: 'What technology is used in Robo trading?',
    text: 'Built using older languages like C, C++, and C#, often facing slippage and latency issues.',
    show: ''
  },
  {
    id: 7,
    title: 'What technology powers Algo trading?',
    text: 'Developed in Python, the most advanced and widely used language in global financial markets.',
    show: ''
  },
  {
    id: 8,
    title: 'What are the risks in Robo trading?',
    text: 'High risk of capital wipeout due to dependency on local infrastructure and basic stop-loss mechanisms.',
    show: ''
  },
  {
    id: 9,
    title: 'Is Algo trading safer?',
    text: 'Yes, it’s more stable and reliable due to cloud hosting, advanced execution speed, and better infrastructure.',
    show: ''
  },
  {
    id: 10,
    title: 'Can anyone build Robo software?',
    text: 'Yes, it requires minimal expertise.',
    show: ''
  },
  {
    id: 11,
    title: 'Can anyone build Algo trading systems?',
    text: 'No, it requires high-level skills, experience, and market knowledge.',
    show: ''
  }
];

export default dataFaqs;
